module.exports = __webpack_public_path__ + "static/media/capture_session_01.534f07ac.png";